<template>
<div class="container">
    <!-- <p><strong>Code Value: {{ decToHexResponse }} </strong></p>
    <div>
        <p>Dec To Hex Table:</p>
        <p>{{codeValue}}</p>
    </div> -->
    <div class="qr-container">
        <h4>VIN Hex - Instructions</h4>
        <div>
            <div>
                <p>Input your vin value</p>
                <p>Click "Generate Hex" button</p>
                <p>Watch magic happen (below the button)</p>
            </div>

            <div class="row">
                <div class="input-group mb-3 col">
                    <label class="input-group-text">VIN Value:</label>
                    <input type="text" class="form-control" id="codeInput" v-model="codeInput" placeholder="add a VIN">
                </div>
            </div>
            <div class="row">
                <div class="py-3" style="text-align: center">
                    <button class="ty-button" @click="generate">Generate Hex</button>
                </div>
            </div>
            <div class="row mb-4">
                <div v-if="hexArrayDisplayOne" class="col-4"> 
                <div>
                    <h3>CAN ID 580 DL 8</h3>
                    <div v-for="hexes in hexArrayDisplayOne" v-bind:key="hexes.index" class="hexes-cont">
                        <div>{{ hexes}}</div>
                    </div>
                </div>
                </div>
                <div v-if="hexArrayDisplayTwo" class="col-4">
                    <div>
                        <h3>CAN ID 581</h3>
                        <div v-for="hexes in hexArrayDisplayTwo" v-bind:key="hexes.index" class="hexes-cont">
                            <div>{{ hexes}}</div>
                        </div>
                    </div>
                </div>
                <div v-if="hexArrayDisplayThree" class="col-4">
                    <div>
                        <h3>CAN ID 582 </h3>
                        <div v-for="hexes in hexArrayDisplayThree" v-bind:key="hexes.index" class="hexes-cont">
                            <div>{{ hexes}}</div>
                        </div>
                        <div>
                            (the other seven are 0x00)
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    

</div>
</template>

<script>
//import hex from 'ascii-hex';
const hex = require('ascii-hex')
import {
    analytics
} from '../config/firebaseInit'

export default {
    name: 'HexAscii',
    data: function () {
        return {
            codeInput: '',
            codeValue: '',
            decToHexResponse: '',
            hexArrayDisplay:[],
            hexArrayDisplayOne:null,
            hexArrayDisplayTwo:null,
            hexArrayDisplayThree:null
        }
    },
    created() {
        analytics.logEvent('hex-ascii');
    },
    methods: {
        generate: function () {
            // Test VIN MM688663867705885
            //const vin = 'MM688663867705885'
            const charArray = this.codeInput.trim().split('',17)
            //const charArray = Array.from(this.codeInput)
            if(charArray.length != 17){
                alert("This is an invalid VIN")
                return
            }
            else{
                let hexArray = []
                let decToHexArray = []
                for (let i=0; i <= charArray.length -1; i++) {
                    if(hex(charArray[i]) != null) {
                        const decValue = hex(charArray[i])
                        //console.log("char array" +i+": "+charArray[i]+" = "+decValue)
                        //console.log("dec to hex: ", decValue.toString(16))
                        const convertedValue = ''+decValue+' '
                        hexArray[i] = convertedValue;
                        decToHexArray[i] = "0x"+decValue.toString(16)+" ";
                    }
                }
                //this.hexArrayDisplay = decToHexArray
                var chunks = function(array, size) {
                    // var results = [];
                    // while (array.length) {
                    //     results.push(array.splice(0, size));
                    // }
                    // return results;
                    return array.splice(0, size)
                };
                const arrayPartOne = chunks(decToHexArray,8)
                this.hexArrayDisplayOne = arrayPartOne;
                const arrayPartTwo = chunks(decToHexArray,8)
                this.hexArrayDisplayTwo = arrayPartTwo;
                const arrayPartThree = chunks(decToHexArray,1)
                this.hexArrayDisplayThree = arrayPartThree;
                this.decToHexResponse = decToHexArray.toString();

            }
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
    font-family: ToyotaType-Regular;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.ty-button {
    background: #D92429;
    border-radius: 0px;
    width: 343px;
    height: 64px;
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
}

.qr-container {
    padding-top: 40px;
    text-align: center;
    height: 300px;
    /*background-color: #4281ff;*/
    /* height: 540px; */
}

.hexes-cont {
    padding:3px;
    border:3px;
    border-style: solid;
    border-color:black;
}
</style>
